import { useToast } from "@/components/common/toast/ToastProvider";
import { useMutation } from "@tanstack/react-query";
import { exportCSVService } from "@/services/csvService";
import { ToastType } from "@/components/common/toast/Toast";
import { TIME_FORMAT } from "@/constants/app_constants.ts";
import dayjs from "dayjs";
import { EXPORT_CSV_SUCCESSFULLY } from "@/constants/strings";
import { InputAndDateFilter } from "@/types/SitesSketches";

export const useExportCsv = (fileName: string, urlPath: string, exportCsvFilters: InputAndDateFilter) => {
  const { showToast } = useToast();

  const parsedFromDate = dayjs(exportCsvFilters?.fromDate);
  const parsedToDate = dayjs(exportCsvFilters?.toDate);

  const getDeviceTimezone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

  const filtersWithTimezone = {
    ...exportCsvFilters,
    timezone: getDeviceTimezone()
  };

  return useMutation({
    mutationFn: () =>
      exportCSVService.exportCSVService(
        {
          exportCsvFilters: filtersWithTimezone,
          timezone: "Asia/Bangkok"
        },
        urlPath
      ),
    onSuccess: (response: unknown) => {
      const blob = (response as { data: Blob })?.data;
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}_${parsedFromDate.format(TIME_FORMAT.CSV_DATE)}_${parsedToDate.format(TIME_FORMAT.CSV_DATE)}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
      showToast(ToastType.success, EXPORT_CSV_SUCCESSFULLY);
    },
    onError: (error: unknown) => {
      showToast(ToastType.error, (error as Error).message);
    }
  });
};
